import 'svelte/internal/disclose-version';

Logo[$.FILENAME] = 'src/web/logo.svelte';

import * as $ from 'svelte/internal/client';

var root = $.add_locations(
	$.from_svg(
		`

<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="-114 -114 228 228"><mask id="g"><rect x="-114" y="-114" width="228" height="228" fill="#fff"></rect><g fill="none" stroke="#000" stroke-width="24"><path d="M87.7 -132.4A43 43 0 0 0 44.7 -89.4V-44.7"></path><path d="M132.4 -87.7A43 43 0 0 1 89.4 -44.7H-1.7A43 43 0 0 0 -44.7 -1.7V89.4A43 43 0 0 1 -87.7 132.4"></path><path d="M44.7 -12V1.7A43 43 0 0 1 1.7 44.7H-89.4A43 43 0 0 0 -132.4 87.7"></path></g><path d="M-12 12V2A14 14 0 0 1 2 -12H44.7V12Z" fill="#000"></path></mask><rect x="-114" y="-114" width="228" height="228" fill="currentColor" mask="url(#g)"></rect></svg>`,
		1
	),
	Logo[$.FILENAME],
	[
		[
			5,
			0,
			[
				[
					5,
					105,
					[[5, 118], [5, 180, [[5, 227], [5, 280], [5, 384]]], [5, 464]]
				],
				[5, 531]
			]
		]
	]
);

function Logo($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Logo);

	let className = $.prop($$props, 'class', 3, "");
	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root();
	var svg = $.sibling($.first_child(fragment));

	$.template_effect(() => $.set_class(svg, 0, $.clsx(className())));
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Logo = $.hmr(Logo);

	import.meta.hot.accept((module) => {
		Logo[$.HMR].update(module.default);
	});
}

export default Logo;